export enum INSURANCE_PROVIDER_TRANSACTION_TYPE {
  ELIGIBILITY_INQUIRY = '270', // 271 response
  CLAIM_STATUS = '276', // 277 response
  AUTH_REF = '278',
  SERVICE_REVIEWS_INQUIRY = '278I',
  CLAIM_SUBMIT = '837',
  REMITTANCE_ADVICE = '835',
}
